jQuery( document ).ready(function($) {
  $('.section-banner .banners.owl-carousel').owlCarousel({
      loop:false,
      margin:0,
      nav:false,
      dot:true,
      items:1
  })
  
  $('.collection_items').owlCarousel({
      loop:false,
      margin:12,
      nav:false,
      dots:false,
      responsive:{
        0:{
            items:1
        },
        414:{
            items:2
        },
        768:{
            items:3
        }
    }
  })
  
  $('.related-blogs .owl-carousel ').owlCarousel({
      loop:false,
      margin:29,
      nav:false,
      dots:false,
      responsive:{
        0:{
            items:1
        },
        500:{
            items:2
        },
        768:{
            items:3
        }
    }
  })

  $(".field input, .field textarea").focus(function(){
      $(this).prev().addClass('focus');
  });
  
  $(".field input, .field textarea").blur(function(){
      $(this).prev().removeClass('focus');
  });
  
//match height
  function alignHeight(element){
    $(element).css({'height':''});
      var minHeight = '';
        $(element).each(function(){
           if(minHeight < $(this).outerHeight()){
               minHeight = $(this).outerHeight();
           }
         })
         if(minHeight > 0){
           $(element).css({'height':minHeight});
          }
        }

  if($(window).width()>=768){
     alignHeight('.section.section-contact.about .locations .address');
 
  }
  
   $(window).resize(function(){
    if($(window).width()>=768){
       alignHeight('.section.section-contact.about .locations .address');

    }
  })
  
   var title = $('#rap__med__instagram h2')
 	console.log(title.length)
     if(title.length >0){
       var ss =title.text();
       console.log(ss);
       var array_cate_name = title.text().split(" ");
       var number_element= array_cate_name.length;
       var removeElement =  array_cate_name.slice(0,-1)
       var h2_html = removeElement.join(" ") + " <span class='change-color'>" + array_cate_name[number_element - 1] + " " + "</span>"  + array_cate_name[number_element - 1];    
       if(number_element > 2){
         title.html(h2_html);
         console.log(h2_html)
       }
     }
   
         
})

 